import { useCallback } from 'react';
import { useQueryClient } from '@tanstack/react-query';
import { useTRPCAPI, useTRPCMutation } from '../../../trpc/trpc';

export const useTrackPlaylistByUrl = () => {
  const trpcMusicAPI = useTRPCAPI();
  const queryClient = useQueryClient();

  const mutation = useTRPCMutation(trpcMusicAPI.playlists.trackByUrl.mutationOptions());

  const trackPlaylist = useCallback(
    async (url: string): Promise<string> => {
      const result = await mutation.mutateAsync(
        { url },
        {
          onSuccess: () => {
            Promise.all([
              queryClient.invalidateQueries({
                queryKey: trpcMusicAPI.playlists.listFollowed.queryKey(),
              }),
              queryClient.invalidateQueries({
                queryKey: trpcMusicAPI.playlists.isFollowing.queryKey(),
              }),
            ]).catch(console.error);
          },
        }
      );

      return result.playlistId;
    },
    [mutation, queryClient, trpcMusicAPI.playlists.listFollowed, trpcMusicAPI.playlists.isFollowing]
  );

  return {
    trackPlaylist,
    isPending: mutation.isPending,
    error: mutation.error,
    reset: mutation.reset,
  };
};
